// Modules
import { useState } from "react"
import { useForm } from "react-hook-form"

// Constants
import { ERROR_MESSAGES } from "~constants/errorMessages"

// Utils
import { Validation } from "~utils/regexValidations"

// Services
import AuthService from "~services/AuthService"

// Components
import Input from "~app/Input"
import Title from "~styled/title"
import { FormSubmit } from "~styled/form"
import { AuthForm, AuthError, AuthDescription } from "~styled/auth"

interface ResetPasswordFormProps {
  handler: (_username: string) => void
}

const ResetPasswordForm = (props: ResetPasswordFormProps) => {
  // Set component state
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>(null!)

  // Form definition
  const { formState: { errors }, register, clearErrors, handleSubmit } = useForm({
    defaultValues: { email: "" },
  })

  // Method to handle submit
  const onSubmit = async data => {
    setIsLoading(true)

    try {
      await AuthService.getResetPassword(data.email)
      props.handler(data.email)
      return
    } catch (error) {
      setErrorMessage(ERROR_MESSAGES.GENERIC)
    }

    setIsLoading(false)
  }

  return (
    <AuthForm onSubmit={handleSubmit(onSubmit)}>
      <Title>Forgot your password?</Title>

      <AuthDescription>
        We’ll help you reset it and get back on track.
      </AuthDescription>

      <Input
        name="email"
        label="Email"
        register={register("email", {
          required: true,
          pattern: {
            value: Validation.email,
            message: ERROR_MESSAGES.INVALID_EMAIL,
          },
        })}
        onChange={() => clearErrors()}
        errorMessage={
          errors.email &&
          (errors.email.message || ERROR_MESSAGES.FIELD_REQUIRED)
        }
      />

      <FormSubmit type="submit" disabled={isLoading}>
        Next
      </FormSubmit>

      {!!errorMessage && <AuthError>{errorMessage}</AuthError>}
    </AuthForm>
  )
}

export default ResetPasswordForm
